import create from 'zustand';

const useEshop = create((set) => ({
    settings: {
        mainUrl: 'https://mojavec.com/',
        version: "v0.029",
        deployDate: "28.01.2026",
        theme: 'light',
        language: 'sk',
        currency: 'EUR',
        deliveryFreeFrom:60, //if 0,no free deliveryclaude
        deliveryOptions: [
            { id: 0, name: 'Odberné miesto GLS/AlzaBox', cost: 2.90, costCZ: 5.90, isPickupPoint: true },
            { id: 1, name: 'GLS kuriér', cost: 3.90, costCZ: 8.90, isPickupPoint: false },
            { id: 2, name: 'Osobný odber', cost: 0, costCZ: 0, isPickupPoint: false, skOnly: true }
        ],
        paymentOptions: [
            { id: 0, name: 'Bankový prevod, platba vopred', cost: 0, visible_in_delivery:[0,1,2] },
            { id: 1, name: 'Dobierka', cost: 1, visible_in_delivery:[0,1] },
            { id: 2, name: 'Platba v predajni', cost: 0, visible_in_delivery:[2] }
            ],
        maleSizes: [ "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
        femaleSizes: ["XS", "S", "M", "L", "XL","2XL","3XL"],
        allOfSizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
        allSizes: {
            "143": "110",
            "144": "122",
            "145": "134",
            "146": "146",
            "147": "158",
            "160": "2XL",
            "161": "3XL",
            "162": "4XL",
            "163": "5XL",
            "215": "Detská",
            "158": "L",
            "157": "M",
            "149": "S",
            "216": "Uni",
            "159": "XL",
            "148": "XS",
            // sice tag velkosti aj ked je to strih ale plati to pre siltovky
            "174": "UNI",
            "173": "Detská",
            "172": "Chlapec",
            "154": "Dievča",
            "153": "Ženská",
            "152": "Mužská",
            // Kariban detske velkosti (roky)
            "276": "4-6 rokov",
            "277": "6-8 rokov",
            "278": "8-10 rokov",
            "279": "10-12 rokov",
            "280": "12-14 rokov",
            // Detske mikiny velkosti (roky) - tagy 250, 290
            "284": "3/4",
            "285": "5/6",
            "286": "7/8",
            "287": "9/11",
            "288": "12/13"
        },
        solsKidsSizes: {
            "268": "2A",
            "269": "4A",
            "270": "6A",
            "271": "8A",
            "272": "10A",
            "262": "12A",
            // "274": "86-94"
        },
        banners:null,
        bottomHomeBanner:null,
        bottomProductBanner:null
    },
    setSettings: (newSettings) => set((state) => ({ settings: { ...state.settings, ...newSettings } }))
}));

export default useEshop;